// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29iUw","field":"styles_field__2Hm55","fieldCol":"styles_fieldCol__2JJMy","diffCol":"styles_diffCol__3QijS","diff":"styles_diff__1IeSW"};